<ep-remove-cart-line-from-cart [product]="product" [marginRightPx]="8"></ep-remove-cart-line-from-cart>
<ep-cart-line-quantity-setter
        class="quantity-setter"
        [product]="product"
        [size]="size"
></ep-cart-line-quantity-setter>
